module.exports = __webpack_public_path__ + "img/box-decline.85af5590.svg";